import type { paths } from "../api/schema";
import { getRuntimeConfig } from "../config";

const transcriptAudioPath = "/v1/transcripts/{id}/audio" satisfies keyof paths;

export function transcriptAudioUrl(transcriptId: string): string {
  // Media elements need the real endpoint URL so the browser can negotiate
  // byte ranges; JSON/resource reads still go through the generated client.
  const path = transcriptAudioPath.replace(
    "{id}",
    encodeURIComponent(transcriptId),
  );
  const apiBaseUrl = getRuntimeConfig().apiBaseUrl.replace(/\/+$/, "");

  return `${apiBaseUrl}${path}`;
}
